import { render } from "./LogImgView.vue?vue&type=template&id=07e660c8"
import script from "./LogImgView.vue?vue&type=script&lang=js"
export * from "./LogImgView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__